import { render, staticRenderFns } from "./AnBehaviour.vue?vue&type=template&id=ecaf1352&scoped=true&"
import script from "./AnBehaviour.vue?vue&type=script&lang=js&"
export * from "./AnBehaviour.vue?vue&type=script&lang=js&"
import style0 from "./AnBehaviour.vue?vue&type=style&index=0&id=ecaf1352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaf1352",
  null
  
)

export default component.exports